/* eslint-disable prefer-destructuring */
import { h, render } from 'preact';
import { useEffect } from 'preact/hooks';
import { useProduct } from './product-context';

const SizeVariantSelector = (props) => {
  const { onSizeSelected } = props;
  const {
    activeVariant,
    handleVariantChange,
    sizeOptions,
    selectedFit,
    selectedOptions,
    skipLengthValidation,
    activeProduct,
    sizeGuides: { linkText, bodyHtml },
  } = useProduct();

  const length = activeProduct?.tags.find((a) => a.includes('length'));

  const groupTag = activeProduct?.tags.find((a) => a.includes('group'));
  const activeId = groupTag.split('::')[1];

  const productActiveId = activeId.includes('_')
    ? activeId.split('_')[0]
    : activeId;

  window.FitPredictorProduct = {
    productId: productActiveId, // Product ID for `group::Oahu Twill_sale`  is `Oahu Twill`
    color: activeVariant.selectedOptions[1]?.value,
    price: activeVariant.price.amount,
    salePrice: activeVariant.compareAtPrice?.amount,
    sizeType: length,
    variants: activeProduct.variants.edges,
  };

  const { name, values } = sizeOptions;
  if (!values) return null;

  const includesSize = sizeOptions.values.includes(selectedOptions.Size);
  let currentSize;

  if (includesSize) {
    currentSize = selectedOptions.Size;
  } else {
    currentSize = sizeOptions.values[0];
  }

  const remainingStock = activeVariant?.inventory_quantity;

  // Build an array of relevant variants for the current product based on the selected options
  const relevantVariants = activeProduct.variants.edges.filter((variant) => (
    variant?.node?.selectedOptions[1]?.value === selectedOptions.Color
      && (skipLengthValidation
      || variant?.node?.selectedOptions[2]?.value === selectedOptions.Length)
  ));

  const selectedSizeTitle = relevantVariants.find(
    (variant) => variant.node.selectedOptions[0].value === currentSize,
  )?.node.title;

  onSizeSelected(selectedSizeTitle);

  const fitValues = selectedFit === 'regular' ? values.filter((value) => !value.toLowerCase().includes('tall')) : values.filter((value) => value.toLowerCase().includes('tall'));

  const valueEls = fitValues.map((value) => {
    const isAvailable = relevantVariants.find(
      (variant) => variant.node.selectedOptions[0].value === value,
    )?.node.available;

    return (
      <button
        data-wair-option-value={value}
        className={`${
          currentSize === value
            ? 'border-text-1 bg-text-1 text-white'
            : 'border-grey-400 bg-white text-black'
        } ${
          !isAvailable && 'text-grey-400 unavailable'
        } flex items-center justify-center h-[44px] rounded-md text-sm border`}
        onClick={() => handleVariantChange(value, name)}
      >
        {value}
      </button>
    );
  });

  return (
    <div id="sizeselector">
      <div className="text-[14px] leading-[18px] mb-[6px] flex justify-between">
        <div className="uppercase">
          {name}
          {remainingStock <= 5 && remainingStock > 0 && (
            <span className="capitalize text-red ml-[4px]">
              Only {remainingStock} left!
            </span>
          )}
        </div>
        <div class="predict-placement"
          data-predict-product-key={activeProduct.handle}
          data-predict-product-name={activeProduct.title}
          data-predict-product-img={activeVariant.image?.url}
        />
      </div>
      <div class="fp-container">
        <div
          className="fp-root mb-[6px]"
          data-product-id={productActiveId}
        ></div>
      </div>
      <div data-wair-option-name="Size" data-wair-product-key={activeProduct.handle} className="min-h-[44px] grid grid-cols-6 md:grid-cols-7 gap-y-[10px] gap-x-[13px] mb-[30px]">
        {valueEls}
      </div>
    </div>
  );
};

export default SizeVariantSelector;
